import { ContentCluster } from '@app/components/base/content-structure/ContentCluster';
import { AuditReportsReportRun } from '@mi-front/api-v2';
import { Box } from '@mui/material';
import { defineMessage, FormattedMessage } from 'react-intl';
import { getBroadcastEvidenceConfig } from './broadcast-evidence-config';
import { BroadcastEvidencePackageDownload } from './BroadcastEvidencePackageDownload';
import { BroadcastEvidenceReportInfo } from './BroadcastEvidenceReportInfo';
import { BroadcastEvidenceTable } from './BroadcastEvidenceTable';

interface Props {
  report: AuditReportsReportRun;
}

const packageTitleMessage = defineMessage({
  id: 'audit.broadcastEvidence.packageTitle',
  defaultMessage: 'Export de evidencia',
});

const evidenceTitleMessage = defineMessage({
  id: 'audit.broadcastEvidence.evidenceTitle',
  defaultMessage: 'Evidencias',
});

/**
 * Detail body for a broadcast evidence report run.
 */
export function BroadcastEvidenceReportDetail({ report }: Props) {
  const config = getBroadcastEvidenceConfig(report);

  return (
    <Box>
      <BroadcastEvidenceReportInfo report={report} />

      <Box mt={3}>
        <ContentCluster title={<FormattedMessage {...packageTitleMessage} />} divider={false}>
          <BroadcastEvidencePackageDownload report={report} />
        </ContentCluster>
      </Box>

      <Box mt={3}>
        <ContentCluster title={<FormattedMessage {...evidenceTitleMessage} />}>
          <BroadcastEvidenceTable evidence={config.evidence ?? []} />
        </ContentCluster>
      </Box>
    </Box>
  );
}
